import type { FC } from "react";
import { Form } from "react-bootstrap";
import { CompanyUserRole } from "shared";
import { useForm } from "../common/form/useForm";
import { Modal, useModal } from "../common/modal/Modal";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { useCompanyActions } from "../company/useCompany";
import { Button } from "../components/Button";

type Props = {
	companyId: number;
};

export const ModalInviteUser: FC<Readonly<Props>> = ({ companyId }) => {
	const { close } = useModal();
	const { addCompanyUser } = useCompanyActions();
	const form = useForm({
		initialValues: {
			email: "",
			role: CompanyUserRole.MEMBER as CompanyUserRole,
		},
		onSubmit: async (data) => {
			close();
			await addCompanyUser.mutateAsync({
				companyID: companyId,
				userEmail: data.email,
				role: data.role,
			});
		},
	});

	return (
		<Modal>
			<h2 className="pb-2">Add a user to your company!</h2>

			<Form onSubmit={form.handleSubmit}>
				<ExtraForm.Group required label="Email">
					<ExtraForm.Control
						type="email"
						placeholder="email@example.com"
						{...form.getFieldProps("email")}
						{...form.getFieldState("email")}
					/>
				</ExtraForm.Group>

				<Form.Group className="mb-3">
					<Form.Label>User Type</Form.Label>
					<div>
						<Form.Check
							type="radio"
							id="role-full-user"
							label="Full User"
							name="role"
							value={CompanyUserRole.MEMBER}
							checked={form.values.role === CompanyUserRole.MEMBER}
							onChange={() =>
								form.setFieldValue("role", CompanyUserRole.MEMBER)
							}
						/>
						<Form.Text className="text-muted ms-4 d-block mb-2">
							Full access to all features
						</Form.Text>
						<Form.Check
							type="radio"
							id="role-client-account"
							label="Client Account"
							name="role"
							value={CompanyUserRole.CLIENT_ACCOUNT}
							checked={form.values.role === CompanyUserRole.CLIENT_ACCOUNT}
							onChange={() =>
								form.setFieldValue("role", CompanyUserRole.CLIENT_ACCOUNT)
							}
						/>
						<Form.Text className="text-muted ms-4 d-block">
							Access to Calendar and Reporting only, can approve posts
						</Form.Text>
					</div>
				</Form.Group>

				<Button type="submit" full>
					Invite
				</Button>
			</Form>
		</Modal>
	);
};
